<template>
  <div class="bind-data-container">

    <div v-if="selectProp.key" class="change-key">
      已选的属性：{{ selectProp.key }}
    </div>

    <el-autocomplete v-model="keyword" :fetch-suggestions="querySearchAsync" placeholder="请输入内容"
      class="input-with-select" @select="handleSelect">
      <template slot-scope="{ item }">
        <div class="item-list">
          <div class="name">{{ item.className }}-{{ item.controlName }}</div>
          <el-button @click="changeSearchProp(item)" size="mini">选择绑定的属性</el-button>
        </div>

      </template>
    </el-autocomplete>

    <el-collapse v-model="moduleActiveNames" class="list">
      <el-collapse-item title="所有模块" name="1">
        <div class="bind-data-module-item" :class="currentModule == index ? 'module-active' : ''"
          v-for="(item, index) in modules" @click="changeModule(item, index, 1)">
          <div class="module-name">
            {{ item.controlName }} ——【{{ item.className }}】 | {{ item.showType }}
          </div>
          <div>
            <el-popover placement="left" width="400" trigger="click" size="mini" v-if="currentModule == index">
              <div>
                <div class="module-info select-prop-data" v-for="(item3, key3) in item" @click="changeProp(key3, item)">
                  <div class="name">{{ key3 }} :</div>
                  <div class="value">{{ item3 }}</div>
                </div>
              </div>
              <el-button slot="reference" size="mini">选择绑定的属性</el-button>
            </el-popover>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item title="控制模式" name="2">
        <div class="bind-data-module-item" :class="currentCtrlMode == index ? 'module-active' : ''"
          v-for="(item, index) in ctrlMode" @click="changeModule(item, index, 2)">
          <div class="module-name">
            {{ item.dataName }}
          </div>
          <div>
            <el-popover placement="left" width="400" trigger="click" size="mini" v-if="currentCtrlMode == index">
              <div>
                <div class="module-info select-prop-data" v-for="(item3, key3) in item" @click="changeProp(key3, item)">
                  <div class="name">{{ key3 }} :</div>
                  <div class="value">{{ item3 }}</div>
                </div>
              </div>
              <el-button slot="reference" size="mini">选择绑定的属性</el-button>
            </el-popover>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item title="监控模块" name="3">
        <div class="bind-data-module-item" :class="currentMonitor == index ? 'module-active' : ''"
          v-for="(item, index) in monitor" @click="changeModule(item, index, 3)">
          <div class="module-name">
            {{ item.controlName }} ——【{{ item.className }}】
          </div>
          <div>
            <el-popover placement="left" width="400" trigger="click" size="mini" v-if="currentMonitor == index">
              <div>
                <div class="module-info select-prop-data" v-for="(item3, key3) in item" @click="changeProp(key3, item)">
                  <div class="name">{{ key3 }} :</div>
                  <div class="value">{{ item3 }}</div>
                </div>
              </div>
              <el-button slot="reference" size="mini">选择绑定的属性</el-button>
            </el-popover>
          </div>
        </div>
      </el-collapse-item>

      <!-- 统计================= -->
      <el-collapse-item title="统计模块" name="4">
        <div class="bind-data-module-item" :class="currentstatisicsData == index ? 'module-active' : ''"
          v-for="(item, index) in statisicsData" @click="changeModule(item, index, 4)">
          <div class="module-name">
            {{ item.name }}
          </div>
          <div>
            <el-popover placement="left" width="400" trigger="click" size="mini" v-if="currentstatisicsData == index">
              <div>
                <div class="module-info select-prop-data" v-for="(item3, key3) in item" @click="changeProp(key3, item)">
                  <div class="name">{{ key3 }} :</div>
                  <div class="value">{{ typeof item3 !== 'object' ? item3 : '[...]' }}</div>
                </div>
              </div>
              <el-button slot="reference" size="mini">选择绑定的属性</el-button>
            </el-popover>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="dialog-footer">
      <el-button @click="$emit('close')">取 消</el-button>
      <el-button type="primary" @click="confirm">确 定</el-button>
    </div>


    <el-dialog title="绑定数据" :visible.sync="dialogFormVisible" :modal="false" class="search-data-dialog">
      <div class="search-data-content">
        <div v-if="selectProp.key" class="change-key">
          已选的属性：{{ selectProp.key }}
        </div>

        <div class="module-info select-prop-data" v-for="(item3, key3) in searchData"
          @click="changeProp(key3, searchData)">
          <div class="name">{{ key3 }} :</div>
          <div class="value">{{ item3 }}</div>
        </div>
        <div class="dialog-footer">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button type="primary" @click="searchConfirm">确 定</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>
<script>
export default {
  data() {
    return {
      moduleActiveNames: 1,
      modules: [], //所有模块数据
      currentModule: -1,
      currentCtrlMode: -1,
      currentMonitor: -1,
      currentstatisicsData: -1,
      selectProp: { key: "", value: "" },
      ctrlMode: [], //控制数据
      monitor: [], //监控数据
      statisicsData: [],//统计数据
      keyword: "",
      dialogFormVisible: false,
      searchData: {}
    };
  },
  created() {
    this.DPC = this.$Core.getProvider("DPC");
    this.init();
  },
  methods: {
    changeSearchProp(item) {
      this.searchData = item;
      this.keyword = item.controlName;
      this.dialogFormVisible = true;
    },
    querySearchAsync(queryString, cb) {
      let data = this.modules;
      let result = queryString
        ? data.filter((item) => {
          if ((item.className.toLowerCase().indexOf(queryString.toLowerCase()) > -1) || (item.controlName.toLowerCase().indexOf(queryString.toLowerCase()) > -1)) {
            return item;
          }
        })
        : data;
    
      cb(result || []);
    },
    handleSelect(item) {
      this.keyword = item.className
      this.changeSearchProp(item)
    },
    async init() {
      this.modules = this.DPC.allModules;
      this.ctrlMode = this.DPC.ctrlMode;
      this.monitor = this.DPC.monitor;
      this.statisicsData = await this.DPC.bindTypeStatistics(null, { BeginTime: this.DPC.threeDaysAgo(2), EndTime: new Date() });
      if (!this.statisicsData) {
        this.$message.error("获取统计数据失败,请检查是否已经绑定对应设备");
      }
    },
    // 选择绑定的属性
    changeProp(key3, item) {

      this.selectProp.key = key3;
      this.selectProp.value = item[key3];
    },
    closeDialog(){
      this.dialogFormVisible = false;
      this.keyword = '';
      this.searchData = {};
      this.selectProp = { key: "", value: "" };
    },
    searchConfirm(){
      this.dialogFormVisible = false;
      this.$emit(
        "confirm",
        { selectModule: this.searchData, selectProp: this.selectProp } || null
      );
    },

    confirm() {
      this.$emit(
        "confirm",
        { selectModule: this.selectModule, selectProp: this.selectProp } || null
      );
    },
    // 选择模块
    changeModule(moduel, index, num) {
      this.selectProp = { key: "", value: "" };
      this.selectModule = moduel;
      this.currentModule = this.currentCtrlMode = this.currentMonitor = -1;
      switch (num) {
        case 1:
          this.currentModule = index;
          break;
        case 2:
          this.currentCtrlMode = index;
          break;
        case 3:
          this.currentMonitor = index;
          break;
        case 4:
          this.currentstatisicsData = index;
          break;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.input-with-select {
  width: 100%;
}

.item-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.bind-data-container {
  height: 60vh;
  overflow-y: auto;

  .bind-data-module-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
    cursor: pointer;

    &:hover {
      background: rgba($color: #000000, $alpha: 0.2);
    }

    .el-icon-warning {
      font-size: 18px;
    }
  }

  .module-info {
    display: flex;
    align-items: center;
  }

  .module-active {
    background: rgba($color: #000000, $alpha: 0.2);
  }

  .dialog-footer {
    position: absolute;
    padding: 10px;
    bottom: 0;
    right: 0;
  }
}

.change-key {
  position: fixed;
  background: #fff;
  width: 100%;
  color: #0754e4;
  padding-bottom: 15px;
}

.list {
  margin-top: 40px;
  padding: 10px;
}

.search-data-dialog {
  height: 100%;
}

.search-data-content {
  height: 100%;
  background-color: #fff;
}
</style>